import React from 'react';
import { icons } from './components';
import { SVGIconProps } from '../../../types/icons'

const SvgIcon = ({
    type = 'Bank',
	width = '16px',
	height = '16px',
	color = '#000',
	viewBox = '0 0 24 24',
	styles = {},
}: SVGIconProps): JSX.Element => {	
	// To avoid TypeScript throwing an error on the line of code below, (line 15)
	// ensure that whatever type you pass as an index is a subset (or can be found in the) SVGIconProps type
    const IconComponent: (color?: string) => JSX.Element = icons[type] || icons.Sort;

    return (
        <svg xmlnsXlink="http://www.w3.org/1999/xlink" width={width} height={height} viewBox={viewBox} version="1.1" fill={color} style={styles} preserveAspectRatio="xMidYMid meet">
			{IconComponent(color)}
		</svg>
    )
}

export default SvgIcon;
